import { useDispatch } from 'react-redux';
import React, { useContext } from 'react';
import SidebarContext from '../Context/SidebarContext';
import { appActions } from '../../state/modules/app';
import Icon from '@mdi/react';
import { mdiChevronDoubleLeft } from '@mdi/js';
import styled from 'styled-components';

const IconWrapper = styled.div<{ left?: string }>`
  cursor: pointer;
  position: absolute;
  top: 10px;
  left: ${({ left }) => left};
`;

export const SideBarCloseIcon = ({ left }: { left?: string }) => {
  const dispatch = useDispatch();
  const sidebarContext = useContext(SidebarContext);

  return (
    <IconWrapper
      left={left}
      onClick={() => {
        if (!sidebarContext?.closeSidebar) {
          dispatch(appActions.toggleSidebar(true, null));
        } else {
          sidebarContext.closeSidebar();
        }
      }}
    >
      <Icon path={mdiChevronDoubleLeft} size={1} />
    </IconWrapper>
  );
};
